import React, { Component } from 'react';
import '../styles/player-slider.css';

class PlayerSlider extends Component {

    constructor(props) {
        super(props);
        this.slide = this.slide.bind(this);
    }


    addEventListeners() {
        if (!this.refs['ball']) return;
        this.removeEventListeners();
        this.refs['ball'].addEventListener('sn:willmove', this.slide);
    }

    removeEventListeners() {
        if (!this.refs['ball']) return;
        if (this.refs.slider) {
            this.refs.slider.removeEventListener('sn:willmove', this.slide);
        }
    }

    /**
       * Slider side actions
       * @param e
       */
    slide(e) {
        if (this.props.slide) {
            this.props.slide(e);
        }
    }

    componentDidMount() {
        this.addEventListeners();
    }

    componentWillUnmount() {
        this.removeEventListeners();
    }

    render() {

        return (
            <div ref="barContainer" className="player-slider-container">
                <div className="player-slider-bar-duration"></div>
                <div ref="progressNow" 
                    // style={{ width: this.getBarProgressPercent() }} 
                    className="player-slider-bar-now"
                />
                {this.props.withBarTotal ?
                    <div ref="progressTotal" className="player-slider-bar-total-progress"></div>
                    :
                    null
                }
                <a
                    id="player-ui-progress-bar-ball"
                    href="javascript:void(0)"
                    ref="ball"
                    className="player-slider-bar-ball whenfocusable"
                    data-sn-down='.video-player-control-main-button'
                    // style={{ left: this.getBarProgress() }}
                />
                {/* <div ref="ball" className="player-slider-bar-ball whenfocusable"></div> */}
                < div className="player-slider-bar-inner-container"></div>
            </div>
        );
    }
};

export default PlayerSlider;


// WEBPACK FOOTER //
// ./src/playerDomain/components/common/PlayerSlider.js